import { render, staticRenderFns } from "./SensorMtap1V1ControllerTelemetryCard.vue?vue&type=template&id=24a50b2c&scoped=true&"
import script from "./SensorMtap1V1ControllerTelemetryCard.vue?vue&type=script&lang=ts&"
export * from "./SensorMtap1V1ControllerTelemetryCard.vue?vue&type=script&lang=ts&"
import style0 from "./SensorMtap1V1ControllerTelemetryCard.vue?vue&type=style&index=0&id=24a50b2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a50b2c",
  null
  
)

export default component.exports